export const getMedian = (arr) => {
  if (!arr.length) return null;

  const sorted = [...arr].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);

  // Odd length → middle element
  if (sorted.length % 2 !== 0) {
    return sorted[mid];
  }

  // Even length → average of two middle elements
  return (sorted[mid - 1] + sorted[mid]) / 2;
};

export const getAverage = (arr) => {
  if (!arr.length) return null;
  const sum = arr.reduce((a, b) => a + b, 0);
  return sum / arr.length;
};
